import type { HtmlAttributes, HtmlAttributesWithChildren } from '@studio/design-system/props';
import type { Accessor } from '@studio/react-utils';
import type { T_Optional } from '@tryiris-ai/js-types';

/** `<Placeholder>` properties. */
export type PlaceholderProps = Props;

/** `<LeftTray>` properties. */
export type Props = HtmlAttributes;

/** `<Root>` properties. */
export type RootProps = HtmlAttributesWithChildren<{ tab: Accessor<Tab, unknown> }>;

/** `<Trigger>` properties. */
export type TriggersProps = HtmlAttributesWithChildren<
  T_Optional<{ audioCount: number; disabled: boolean; videoCount: number }>
>;

/** Tabs. */
export enum Tab {
  Audio = 'audio',
  Video = 'video'
}
